import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles } from 'tss-react/mui';
import Badge from '@mui/material/Badge';
const useStyles = makeStyles()(theme => ({
    // common styles
    badge: {
        minWidth: '22px',
        height: '22px',
    },
    // Kinds
    inline: {
        alignSelf: 'center',
        position: 'initial',
        transform: 'initial',
        lineHeight: 1,
    },
    noBackground: {
        color: '#DC3C37',
        display: 'contents',
    },
    iconButton: {
        top: '7px',
        right: '5px',
    },
    mobile: {
        top: '6px',
    },
    // Extra colors
    white: {
        background: 'white',
        color: theme.palette.grey[900],
    },
    grey: {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.text.primary,
    },
    orange: {
        backgroundColor: theme.palette.orange.main,
        color: theme.palette.orange.contrastText,
    },
    default: {
        background: theme.palette.orange.main,
        color: theme.palette.white.main,
    },
}));
export var Kind;
(function (Kind) {
    Kind["default"] = "default";
    Kind["mobile"] = "mobile";
    Kind["inline"] = "inline";
    Kind["iconButton"] = "iconButton";
    Kind["noBackground"] = "noBackground";
    Kind["mui"] = "mui";
})(Kind || (Kind = {}));
const customColors = ['white', 'grey', 'orange'];
const BadgeNext = ({ children, badgeContent, color = 'primary', kind = Kind.default, badgeClassName, showZero, ...rest }) => {
    const { classes, cx } = useStyles();
    return (_jsx(Badge, { ...rest, color: customColors.includes(color)
            ? undefined
            : color, badgeContent: badgeContent, classes: {
            badge: cx(badgeClassName, classes[color], kind !== Kind.mui && classes.badge, kind !== Kind.mui && classes[kind]),
        }, showZero: showZero, children: children }));
};
export { BadgeNext };
